"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparisonOperators = void 0;
var comparisonOperators;
(function (comparisonOperators) {
    comparisonOperators["eq"] = "eq";
    comparisonOperators["ne"] = "ne";
    comparisonOperators["ge"] = "ge";
    comparisonOperators["gt"] = "gt";
    comparisonOperators["lt"] = "lt";
    comparisonOperators["le"] = "le";
})(comparisonOperators = exports.comparisonOperators || (exports.comparisonOperators = {}));
//# sourceMappingURL=comparison-operators.js.map